export class StringUtil {

  constructor() {}

  public getCleanLines(text: string): string[] {
    return text.toLowerCase().split('\n').map(
      line => line.replace(/\s+/g, ' '
    ).replace(/^\s/, '').replace(/\s$/, '')).filter(line => line.length > 1)
  }

  public firstNumberOfString(str: string): number {
    return Number(this.firstNumberStrOfString(str))
  }

  public lastNumberOfString(str: string): number {
    str = this.firstNumberStrOfString(str.split('').reverse().join('')).split('').reverse().join('')
    return Number(str)
  }

  public firstNumberStrOfString(str: string): string {
    let start = 0, end = 0
    while (start < str.length && !isDigit(str[start])) {
      start ++
    }
    if (start < str.length) {
      end = start
      while (end < str.length && isDigitOrAllowedSymbols(str[end])) {
        end ++
      }
      return str.slice(start, end).replace(/,/g, '')
    } else {
      return '0'
    }

    function isDigit(c: string): boolean {
      return c >= '0' && c <= '9'
    }

    function isDigitOrAllowedSymbols(c: string): boolean {
      return isDigit(c) || ['.', ','].indexOf(c) >= 0
    }
  }

  get mysqlTime(): string {
    return new Date().toISOString().slice(0, 19).replace('T', ' ')
  }

}



// WEBPACK FOOTER //
// ./src/app/models/text-receipt/string.util.ts